import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsComponent } from './reports.component';
import { MatSelectModule } from '@angular/material/select';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTabsModule } from '@angular/material/tabs';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CertificateOverviewReportComponent } from './certificate-overview-report/certificate-overview-report.component';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { RfccStatusReportComponent } from './rfcc-status-report/rfcc-status-report.component';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CardModule } from 'primeng/card';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { InputTextModule } from 'primeng/inputtext';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { PunchReportComponent } from './punch-report/punch-report.component';
import { StatusCircleModule } from '../shared/status-circle/status-circle.module';
import { ExcelColumnFilterComponent } from '../shared/excel-column-filter/excel-column-filter.component';

@NgModule({
  declarations: [ReportsComponent, CertificateOverviewReportComponent, RfccStatusReportComponent, PunchReportComponent],
  imports: [
    CommonModule,
    MatSelectModule,
    NgxChartsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatPaginatorModule,
    MatButtonModule,
    TableModule,
    TagModule,
    ButtonModule,
    MessageModule,
    ProgressSpinnerModule,
    CardModule,
    SelectModule,
    SelectButtonModule,
    InputTextModule,
    IconFieldModule,
    InputIconModule,
    StatusCircleModule,
    ExcelColumnFilterComponent,
  ],
})
export class ReportsModule {}
